<template>
  <div class="" id="section-map">
    <div class="">
      <!-- <h3 class="title title-with-button">茶區地圖</h3>
            <div class="title-buttons">
                <b-dropdown v-if="show_parameter" variant="success" class="dropdown-selector">

                    <template v-slot:button-content>
                        <strong>{{ show_parameter.text }}</strong>
                    </template>

                    <div class="dropdown-select-area">
                        <b-dropdown-item v-for="(param, idx_param) in list_params" :key="'param-' + +idx_param"
                                        :active="show_parameter.value == param.value"
                                        @click="show_parameter = param">
                                        {{ param.text }}
                        </b-dropdown-item>
                    </div>

                </b-dropdown>
            </div> -->

      <div id="map-param-switch">
        <!-- 2022.02.24 隱藏日期切換按鈕 -->
        <!-- <b-tabs>
                    <b-tab :title="$t('menu.flowering_date')" @click="selected_param = 'flowering_date'"></b-tab>
                    <b-tab :title="$t('menu.blooming_date')" @click="selected_param = 'blooming_date'"></b-tab>
                </b-tabs> -->
      </div>

      <div class="map-background justify-content-center">
        <div id="map-location-point">
          <div class="img-container">
            <img
              v-lazy="
                $config.getAssetsURL('img/main/Taiwan_Map_line_area_color.png')
              "
              :alt="$t('menu.map_of_taiwan')"
              class="rounded taiwan-map"
            />
            <div class="fields">
              <template v-for="(point, idx_point) in station_list">
                <template v-if="point.css_map">
                  <!-- 標點 -->
                  <div
                    v-if="point.css_map.style"
                    class="btn-field"
                    :style="point.css_map.style"
                    :key="'point-' + idx_point"
                    @click="update_selected(point.id)"
                  >
                    <img
                      class="location-icon faa-vertical animated-hover faa-slow"
                      :src="get_display_icon(point.id)"
                      alt="flower icon"
                    />
                    <!-- <i class="fas fa-fan location-icon faa-vertical animated-hover faa-slow"></i> -->
                    <!-- <img v-if="point.field_id != undefined"
                                            class="location-icon faa-vertical animated-hover faa-slow"
                                            :src="$config.getAssetsURL('img/main/rice4.png')" alt="。茶葉圖" />
                                        <img v-else
                                            class="location-icon faa-vertical animated-hover faa-slow"
                                            :src="$config.getAssetsURL('img/main/location_icon.png')" alt="。氣象示意圖" /> -->
                  </div>

                  <!-- 名稱 -->
                  <div
                    v-if="point.css_map.nameStyle"
                    class="btn-field"
                    :style="point.css_map.nameStyle"
                    :key="'name-' + idx_point"
                    @click="update_selected(point.id)"
                  >
                    <div class="location-info">
                      {{ $t("field.name_" + point.id) }}
                    </div>
                  </div>

                  <!-- 數值 -->
                  <!-- 2022.02.24 隱藏地圖上日期 -->
                  <!-- <div v-if="selected_param && data && data[ point.id ]" :key="'value-' + idx_point">
                                        <div v-if="point.css_map.valueStyle && data[ point.id ]" class="btn-field" :style="point.css_map.valueStyle" :key="'value-' + idx_point"
                                            @click="update_selected( point.id )">
                                            <div v-if="data[ point.id ][ selected_param ] != undefined" class="location-value">
                                                {{ $moment( data[ point.id ][ selected_param ] ).format('M/D') }}
                                                <div class="location-value-unit">{{ Get_SensorUnit( selected_param ) }}</div>
                                            </div>
                                        </div>
                                    </div> -->
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-instruction">
        <ul>
          <li v-if="data[1] != undefined">
            {{ $t("menu.info_update") }}：{{
              DateTools.Get_DateTimeZone(data[1].run_time)
            }}
          </li>
          <li>{{ $t("menu.info_description") }}</li>
          <!-- <li>{{ $t("menu.info_description2") }}</li> -->
          <li v-html="$t('menu.info_description2')"></li>
          <li v-html="$t('menu.info_source')"></li>
          <li v-html="$t('menu.recommand_link')"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DateTools from "@/tools/date";

export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      DateTools: DateTools,

      loading: false,
      selected_param: "flowering_date",
      // list_params: [
      //     { text: '氣溫',       value: 'air_temperature' },
      //     { text: '濕度',       value: 'air_humidity' },
      //     { text: '日雨量',     value: 'rainfalls' },
      //     { text: '不顯示數值', value: null },
      // ],
      // show_parameter: undefined,
      // stationsValue: undefined,
      // {
      //     TTES1:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTESA:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES2:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES3:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES4:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES5:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES6:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES7:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES8:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES9:  { air_temperature: 30.5, rainfalls: 0, },
      //     TTES10: { air_temperature: 30.5, rainfalls: 0, },
      //     TTES21: { air_temperature: 30.5, rainfalls: 0, },
      //     TTES22: { air_temperature: 30.5, rainfalls: 0, },
      //     TTES23: { air_temperature: 30.5, rainfalls: 0, },
      //     TTES24: { air_temperature: 30.5, rainfalls: 0, },
      //     TTES25: { air_temperature: 30.5, rainfalls: 0, },
      //     TTES26: { air_temperature: 30.5, rainfalls: 0, },
      //     TTES27: { air_temperature: 30.5, rainfalls: 0, },
      //     C0S710: { air_temperature: 30.5, rainfalls: 0, },
      //     C0Z070: { air_temperature: 30.5, rainfalls: 0, },
      // },
      stationsValue_updated_time: "",
      field_infos: undefined,
    };
  },
  created() {
    // this.get_Map_RealTimeData()
  },
  mounted() {
    document.getElementById("map-location-point").scrollLeft = "80";
    // this.show_parameter = this.list_params[0]
  },
  computed: {
    ...mapState({
      display_station: (state) => state.data.display_station,
      station_list: (state) => state.data.stations_info,
    }),
  },
  methods: {
    // get_Map_RealTimeData ()
    // {
    //     this.loading = true
    //     this.$store.dispatch('data/get_Map_RealTimeData')
    //     .then( res => {

    //         this.stationsValue_updated_time = res.updated_time
    //         this.stationsValue = res.values
    //         this.field_infos = res.fields

    //         this.loading = false
    //     })
    //     .catch( err => {
    //         this.loading = false
    //     })
    // },

    get_display_icon(field_id) {
      let _data = this.data[field_id];
      let today = this.$moment(new Date());
      // let today = this.$moment("2022-04-21");

      if (_data != undefined) {
        if (today.isSameOrAfter(_data.withering_date)) {
          return this.$config.getAssetsURL("img/main/stage_wither.png");
        } else if (today.isSameOrAfter(_data.blooming_date)) {
          return this.$config.getAssetsURL("img/main/stage_flower.png");
        } else if (today.isSameOrAfter(_data.flowering_date)) {
          return this.$config.getAssetsURL("img/main/stage_bud.png");
        }
      }
      // return this.$config.getAssetsURL('img/main/桐花4.png')
      return this.$config.getAssetsURL("img/main/stage_waiting.png");
    },

    go_detail() {
      let html = document.getElementById("section-field-detail");

      html.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    },

    update_selected(station_code) {
      this.go_detail();
      this.$store.commit("data/select_station", station_code);
    },

    // 從 Vuex 取得感測參數的設定
    Get_SensorColor(sensor_param) {
      return {
        color: this.$store.getters["data/get_SensorColor"](sensor_param),
      };
    },
    Get_SensorIcon(sensor_param) {
      return `${this.$store.getters["data/get_SensorIcon"](sensor_param)}`;
    },
    Get_SensorName(sensor_param) {
      return `${this.$store.getters["data/get_SensorName"](sensor_param)}`;
    },
    Get_SensorUnit(sensor_param) {
      return `${this.$store.getters["data/get_SensorUnit"](sensor_param)}`;
    },
    Get_SensorTip(sensor_param, value) {
      switch (sensor_param.toLowerCase()) {
        case "rainfalls":
          return `${this.$store.getters["data/get_Rainfall_Tip"](value)}`;
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss">
$flowering-color: #fe6357;
$blooming-color: #232175;

#map-param-switch {
  position: absolute;
  z-index: 999;
  // top: -12px;
  left: 20px;

  .nav-tabs {
    display: inline-flex;
    padding: 0px !important;
    width: 100% !important;
  }

  .nav-tabs > .nav-item > .nav-link {
    border-radius: 50px;
    padding: 5px 15px;
    background-color: #f5f5f5;
    border: 1px solid $flowering-color;
    color: rgba(35, 33, 117, 0.8);
  }

  .nav-tabs > .nav-item > .nav-link.active {
    color: $blooming-color;
    background-color: $flowering-color !important;
    font-weight: bold;
  }
}
</style>

<style lang="scss" scoped>
$flowering-color: #fe6357;
$blooming-color: #232175;

.section {
  padding-top: 30px;
}

// 地圖設定
$map-width: 500px;
$map-img-height: 600px;
.map-background {
  margin: 0px 5px 40px 5px;
  width: 100%;
  background-color: rgb(245, 245, 245);
  border-radius: 10px;
}
#map-location-point {
  text-align: center;
  // margin: 5px 5px 40px 5px;
  width: 100%;
  max-width: $map-width + 50px;
  background-color: #f5f5f5;
  border-radius: 10px;
  // padding: 40px 10px;
}

.img-container {
  position: relative;
  width: 100%;
  min-width: $map-width;
  // min-height: 50vh;
}

@media only screen and (max-width: 3000px) {
  #map-location-point {
    max-width: $map-width + 15px;
    height: $map-img-height;
  }
  .img-container {
    transform: scale(0.95);
    left: -5%;
  }
}
@media only screen and (max-width: 1200px) {
  #map-location-point {
    height: $map-img-height * 0.9;
  }
  .img-container {
    transform: scale(0.85);
    left: -18%;
    top: -($map-img-height * 0.05);
  }
}
@media only screen and (max-width: 991px) {
  // ipad
  #map-location-point {
    height: $map-img-height * 0.85;
  }
  .img-container {
    transform: scale(0.78);
    left: 0%;
    top: -($map-img-height * 0.08);
  }
}
@media only screen and (max-width: 767px) {
  #map-location-point {
    height: $map-img-height * 0.98;
  }
  .img-container {
    transform: scale(0.9);
    left: 0%;
    top: -($map-img-height * 0.01);
  }
}
@media only screen and (max-width: 574px) {
  #map-location-point {
    overflow-x: hidden;
    overflow-y: hidden;
    height: $map-img-height * 0.83;
  }
  .img-container {
    transform: scale(0.78);
    left: -5%;
    top: -($map-img-height * 0.085);
  }
}
@media only screen and (max-width: 430px) {
  // iphone
  #map-location-point {
    overflow-x: hidden;
    overflow-y: hidden;
    height: $map-img-height * 0.83;
  }
  .img-container {
    transform: scale(0.78);
    left: -5%;
    top: -($map-img-height * 0.085);
  }
}

.img-container img {
  width: auto;
  height: $map-img-height;
}

.img-container .btn-field {
  cursor: pointer;
  position: absolute;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  // color: white;
  font-size: 10px;
  font-weight: 600;
  border: none;
}

// .img-container .btn-field:hover {
//     background-color: black;
// }

.location-info {
  display: inline-block;
  vertical-align: middle;
  margin: 5px; // 10px;
  padding: 0px 5px;
  border-radius: 5px;
  color: $blooming-color;
  line-height: 0.6rem;
  white-space: nowrap;
  // width: 130px;
  // text-align: left;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // background-color: rgba(245, 245, 245, 0.3);

  &:hover {
    transform: scale(1.5);
    // overflow: visible;
  }
}
.location-info.has-alert {
  background-color: rgba(236, 140, 140, 0.9);
  &:hover {
    color: #fdfdb1;
    background-color: rgba(184, 64, 64, 0.9);
  }
}

.location-value {
  display: inline-block;
  vertical-align: middle;
  margin: 5px; // 10px;
  padding: 0px 5px;
  border-radius: 5px;
  color: $flowering-color;
  background-color: #ffeceb;
  font-size: 1rem;

  &:hover {
    transform: scale(1.1);
    color: $blooming-color;
    // background-color: rgba(10, 10, 9, 0.8);
  }
}
.location-value-unit {
  display: inline-block;
  font-size: 0.8rem;
}

$location-icon-size: 25px; //25px;
.location-icon {
  width: $location-icon-size !important;
  height: $location-icon-size !important;

  color: #ffff00;
  font-size: 1.2rem;

  &:hover {
    width: $location-icon-size + 5 !important;
    height: $location-icon-size + 5 !important;
    // transform: scale(1.2);
  }
}

.chart-instruction {
  font-size: 0.9rem;
}
</style>
